import React from 'react';
import { SelectList } from 'components/SelectList/SelectList';
import { formatText } from 'core/i18n';
import { getReferenceOptionsTreatmentByCountry } from 'utilities/multiLanguageHelper';

export const Treatment = ({ hidden, userProfile, userProfileForm, formActions, focus }) => {
    if (hidden) return null;

    return (
        <div className="md-form-group row form__input">
            <div className="col-lg-12">
                <label>{formatText('field-treatment')}</label>
            </div>
            <div className="col-sm-6" data-testid="field-treatment">
                <SelectList
                    value={getReferenceOptionsTreatmentByCountry()[0].value}
                    autofocus={focus.get('treatment')}
                    profileModel="userProfile.treatment"
                    name="treatment"
                    optionsList={getReferenceOptionsTreatmentByCountry()}
                    clearable={false}
                    placeholder=""
                    required
                    userProfile={userProfile}
                    userProfileForm={userProfileForm}
                    formActions={formActions}
                />
            </div>
        </div>
    );
};
